import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { forwardRef } from "react";
import { Typography, type TypographyProps } from "~/common/mui";

type Props = BaseProductElementProps & Omit<TypographyProps, "children">;

export const DesignationV2 = forwardRef<HTMLElement, Props>((props, ref) => {
  const product = useProductContext(props);

  return (
    <Typography ref={ref} {...props}>
      {product.designation}
    </Typography>
  );
});
